import {
    FETCH_LOYALTY_PROGRAM_CAMPAIGNS,
    SAVE_CAMPAIGN,
    CLOSE_CAMPAIGN,
    DELETE_CAMPAIGN
} from '../types';
import api from '../api';

export const fetchLoyaltyProgramCampaigns = (loyaltyProgramId) => {
    return {
        type: FETCH_LOYALTY_PROGRAM_CAMPAIGNS,
        payload: api.loyaltyProgram.get(loyaltyProgramId).campaigns.getFull(),
    };
};

export const saveCampaign = (loyaltyProgramId, campaign) => {
    if (campaign.id) {
        return {
            type: SAVE_CAMPAIGN,
            payload: api.loyaltyProgram.get(loyaltyProgramId).campaigns.update(campaign),
            meta: { campaignId: campaign.id, toastSuccess: true }
        };
    } else {
        return {
            type: SAVE_CAMPAIGN,
            payload: api.loyaltyProgram.get(loyaltyProgramId).campaigns.create(campaign),
            meta: { toastSuccess: true }
        };
    }
};

export const closeCampaign = (loyaltyProgramId, campaignId) => {
    return {
        type: CLOSE_CAMPAIGN,
        payload: api.loyaltyProgram.get(loyaltyProgramId).campaigns.close(campaignId),
        meta: { campaignId, toastSuccess: true }
    };
};

export const deleteCampaign = (loyaltyProgramId, campaignId) => {
    return {
        type: DELETE_CAMPAIGN,
        payload: api.loyaltyProgram.get(loyaltyProgramId).campaigns.delete(campaignId),
        meta: { campaignId, toastSuccess: true }
    };
};